// utils/axiosInstance.js
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Create an instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Response interceptor to handle expired token
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error.response",error);
    if (
      error.response?.status === 401 &&
      error.response?.data?.error === "Login is required"
    ) {
        console.log("inside clearn cookied");
      // Token expired or invalid
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("userInfo"); // optional
      //window.location.href = "/login"; // redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;
